<!-- Copyright (C) 2025 Skylark Drones -->

<template>
  <v-menu
    v-if="hmsMessages.length"
    v-model="showHmsIsland"
    offset-y
    open-on-hover
    close-delay="50"
    nudge-bottom="4"
    rounded="lg"
    transition=""
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-if="concise"
        v-bind="attrs"
        v-on="on"
        :style="{
          backgroundColor: `rgba(from ${getLevelColor(
            hmsMessages[0].level
          )} r g b / 0.2)`,
          color: getLevelColor(hmsMessages[0].level)
        }"
        class="rounded-pill pa-1 d-flex align-center text-body-2 font-weight-bold"
      >
        <v-icon size="18" :color="getLevelColor(hmsMessages[0].level)">
          mdi-information
        </v-icon>
        {{ hmsMessages.length }}
      </div>

      <v-badge
        v-else
        offset-y="10"
        offset-x="15"
        color="rgba(0,0,0, 0.5)"
        :value="hmsMessages.length - 1"
      >
        <template v-slot:badge>
          <span class="font-weight-bold"> +{{ hmsMessages.length - 1 }} </span>
        </template>

        <v-card
          v-bind="attrs"
          v-on="on"
          :color="
            showHmsIsland
              ? 'rgba(0,0,0, 0.5)'
              : getLevelColor(hmsMessages[0].level)
          "
          rounded="pill"
          class="white--text pa-1 pr-2 d-inline-flex align-center text-subtitle-2 overflow-hidden"
          style="transition: all ease-in-out 150ms; max-width: 200px"
        >
          <v-icon class="mr-2" size="20" color="white">
            mdi-information-outline
          </v-icon>
          <span class="text-truncate rounded-0">
            {{ hmsMessages[0].description }}
          </span>
        </v-card>
      </v-badge>
    </template>

    <v-list
      dark
      dense
      two-line
      class="py-0 fade-in"
      width="340"
      style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(12px)"
    >
      <v-list-item
        v-for="(hmsMsg, index) in hmsMessages"
        :key="index"
        style="position: relative"
        class="overflow-hidden"
      >
        <div
          style="
            position: absolute;
            width: 200px;
            aspect-ratio: 1;
            left: 32px;
            top: 32px;
            transform: translate(-50%, -50%);
          "
          :style="{
            background: `radial-gradient(50% 50% at 50% 50%, rgba(from ${getLevelColor(
              hmsMsg.level
            )} r g b / 0.16) 0%, rgba(from ${getLevelColor(
              hmsMsg.level
            )} r g b / 0) 100%)`
          }"
        />

        <v-list-item-icon class="mr-4">
          <div
            class="rounded-circle d-inline-flex align-center justify-center"
            style="width: 32px; height: 32px"
            :style="{
              background: `rgba(from ${getLevelColor(
                hmsMsg.level
              )} r g b / 0.1)`
            }"
          >
            <v-icon :color="hmsLevelInfo[hmsMsg.level].color">
              mdi-information
            </v-icon>
          </div>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize text-body-1 font-weight-medium mb-1"
          >
            {{ hmsMsg.device_domain }} {{ hmsLevelInfo[hmsMsg.level].label }}
          </v-list-item-title>
          <v-list-item-subtitle
            class="text-body-2 font-weight-regular"
            style="color: #bdbdbd; white-space: normal"
          >
            {{ hmsMsg.description }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'HmsErrorIsland',

  props: {
    hmsMessages: { type: Array, default: () => [] },
    concise: { type: Boolean, default: false },
    source: { type: String, required: true }
  },

  data() {
    return {
      showHmsIsland: false,
      hmsLevelInfo: {
        0: { label: 'Notification', color: '#2196F3' },
        1: { label: 'Warning', color: '#FF9500' },
        2: { label: 'Error', color: '#FF4040' }
      }
    }
  },

  watch: {
    showHmsIsland(newVal) {
      if (newVal) {
        this.$analytics.trackHmsErrorView(this.$props.source)
      }
    }
  },

  methods: {
    getLevelColor(severityLevel) {
      return this.hmsLevelInfo[severityLevel].color
    }
  }
}
</script>
<style scoped>
.fade-in {
  animation: fadeIn 150ms ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
</style>
